export const stulya = {
    fabric_type: [
        {
            actual: true,
            name: "stul__sta_1",
            pageName: "sta_1",
            tempName: "sta_1",
            glbPath: "stulya/",
            glbName: "stulya.glb",
            nextMenu: "sta_1",
            menuTitle: "Стул «СТА-1 ESD»",
            title: "Стул «СТА-1 ESD»",
            imgName: "stul__sta_1.png",
            allArrTable: "allStulya",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "stul__sta_2",
            pageName: "sta_2",
            tempName: "sta_2",
            glbPath: "stulya/",
            glbName: "stulya.glb",
            nextMenu: "sta_2",
            menuTitle: "Стул «СТА-2 ESD»",
            title: "Стул «СТА-2 ESD»",
            imgName: "stul__sta_2.png",
            allArrTable: "allStulya",
            defaultWidth: 100,
            defaultDepth: 100,
        },
    ],
    penopoliuretan_type: [],
};
